import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar"
import Home from "./page/Home"
import List from "./page/List"
import Film from "./page/Detail/Film"
import Item from "./page/Detail/Item"
import Paper from "./page/Detail/Paper"
import Df from "./page/Detail/Df"
import Rf from "./page/Detail/Rf"
import Detail from "./page/Detail"
import Guide from "./page/Guide"

function App() {
  useEffect(() => {
    window.gtag("event", "page_view", {
      page_path: window.location.pathname,
      page_search: window.location.search,
    });
  }, [window.location]);

  const [deviceSize, setDeviceSize] = useState('');
  useEffect(() => {
      // Add event listener to handle window resize
      const handleResize = () => {
        const width = window.innerWidth;
        if (width <= 600) {
          setDeviceSize('A');
        } else if (width <= 900) {
          setDeviceSize('B');
        } else if (width <= 1200) {
          setDeviceSize('C');
        } else if (width <= 1800) {
          setDeviceSize('D');
        } else {
          setDeviceSize('E');
        }
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      window.addEventListener('beforeunload', function () {
        localStorage.clear();
      });
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('beforeunload', function () {
          localStorage.clear();
        })
      };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Navbar deviceSize={deviceSize} />}>
            <Route index element={<Home />} />
            <Route path='collection' element={<List />} />
            <Route path='collection/film' element={<Film />} />
            <Route path='collection/item' element={<Item />} />
            <Route path='collection/paper' element={<Paper />} />
            <Route path='collection/df' element={<Df />} />
            <Route path='collection/rf' element={<Rf />} />
            <Route path='collection/detail' element={<Detail />} />
            <Route path='guide' element={<Guide deviceSize={deviceSize} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
  
export default App;
